import SliderSimple from './SliderSimple'
import '../../../styles/Entete.css'

function Entete() {
  return (
    <div className="entete">
      <div>
        <div className="MessageEntete1">DUO DANSE</div>
        <div className="MessageEntete2">Simplement le bonheur de la danse.</div>
      </div>
      <div>
        <SliderSimple />
      </div>
    </div>
  )
}

export default Entete
